import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';

// Admin Pages
import AdminDashboard from './pages/admin/Dashboard';
import Teachers from './pages/admin/Teachers';
import AdminCourses from './pages/admin/Courses';
import DepartmentReports from './pages/admin/DepartmentReports';

// Teacher Pages
import TeacherDashboard from './pages/teacher/Dashboard';
import TeacherCourses from './pages/teacher/Courses';
import CLOs from './pages/teacher/CLOs';

// Common Pages
import Profile from './pages/common/Profile';

import './i18n';

function App() {
    return (
        <AuthProvider>
            <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                <Routes>
                    {/* Public Route */}
                    <Route path="/login" element={<Login />} />

                    {/* Admin Routes */}
                    <Route path="/admin" element={
                        <ProtectedRoute allowedRoles={['admin']}>
                            <Layout />
                        </ProtectedRoute>
                    }>
                        <Route index element={<AdminDashboard />} />
                        <Route path="teachers" element={<Teachers />} />
                        <Route path="courses" element={<AdminCourses />} />
                        <Route path="department-reports" element={<DepartmentReports />} />
                        <Route path="profile" element={<Profile />} />
                    </Route>

                    {/* Teacher Routes */}
                    <Route path="/teacher" element={
                        <ProtectedRoute allowedRoles={['teacher']}>
                            <Layout />
                        </ProtectedRoute>
                    }>
                        <Route index element={<TeacherDashboard />} />
                        <Route path="courses" element={<TeacherCourses />} />
                        <Route path="clos/:courseId" element={<CLOs />} />
                        <Route path="profile" element={<Profile />} />
                    </Route>

                    {/* Default redirect */}
                    <Route path="/" element={<Navigate to="/login" replace />} />
                    <Route path="*" element={<Navigate to="/login" replace />} />
                </Routes>
            </Router>
        </AuthProvider>
    );
}

export default App;
